import { pick as t } from "lodash";
const i = (r) => r.reduce((e, p) => (e.push(t(p, ["label", "value", "initialExpanded"])), p.options && Array.prototype.push.apply(e, p.options), e), []);
export {
  i as f
};
